import React from "react";

/**
 * Highlight occurrences of `q` inside `text` with a <mark> element.
 * Case-insensitive; safe against regex-special characters in the query.
 * Handles null/undefined text (renders empty) and empty query (returns text unchanged).
 */
export function Highlight({ text, q }) {
  const value = text == null ? "" : String(text);
  const query = (q || "").trim();
  if (!query || !value) return <>{value}</>;
  const escaped = query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const parts = value.split(new RegExp(`(${escaped})`, "ig"));
  return (
    <>
      {parts.map((part, i) =>
        part.toLowerCase() === query.toLowerCase()
          ? <mark key={i} className="bg-yellow-200 text-inherit px-0.5 rounded-sm" data-testid="highlight-match">{part}</mark>
          : <span key={i}>{part}</span>
      )}
    </>
  );
}
